import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductKoomverCover } from 'quick-quote/product-life-ready/actions'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'
import BIMESSAGES from 'core/data-model/constants/bi-messages'

export const KoomverCoverProductSelection = ({ getSelectedDisplayProductCode, selectProductKoomverCover }) => {
  const productKoomverCover = [
    {
      text: BIMESSAGES.PLAN_1,
      value: 'KOOMVER-COVER-1',
    },
    {
      text: BIMESSAGES.PLAN_2,
      value: 'KOOMVER-COVER-2',
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">{BIMESSAGES.QQ_SELECT_PLAN}</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductKoomverCover}
        value={getSelectedDisplayProductCode}
        options={productKoomverCover}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedDisplayProductCode: getSelectedDisplayProductCode(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductKoomverCover: bindActionCreators(selectProductKoomverCover, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(KoomverCoverProductSelection)
